import orderStatusOptions from './order-status-options'
import { userEmailHydrator } from '../../fieldOptions/hydrators'

export default [
  {
    name: 'User',
    prop: 'account_id',
    type: 'autocomplete',
    references: 'admin/users',
    referenceValue: 'account_id',
    referenceProp: 'fullname',
    dataHydrator: userEmailHydrator,
    displayProp: 'displayVal',
    showIf: resource => resource.account_type === 'user'
  },
  {
    name: 'Institution',
    prop: 'account_id',
    type: 'autocomplete',
    references: 'admin/institutions',
    referenceValue: 'account_id',
    referenceProp: 'name',
    showIf: resource => resource.account_type === 'institution'
  },
  {
    name: 'Description',
    prop: 'description',
    type: 'text'
  },
  {
    name: 'Order Status',
    prop: 'order_status',
    type: 'select',
    options: orderStatusOptions,
    showIf: resource => !!resource.id
  }
]
